export default __webpack_public_path__ + "locales/si/DeleteDialog.json?hash=1e2eed0aa05e254ad4ded33605ee63ca";